import { render } from "./subadmin.vue?vue&type=template&id=0e71b942&scoped=true"
import script from "./subadmin.vue?vue&type=script&lang=js"
export * from "./subadmin.vue?vue&type=script&lang=js"

import "./subadmin.vue?vue&type=style&index=0&id=0e71b942&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e71b942"]])

export default __exports__